export default __webpack_public_path__ + "static/5-min-alarm-clock-icon-d76699069674266b968141623621f73e.png";